import { forwardRef } from 'react';

import { Skeleton, ToggleGroupItem } from '@repo/videa-components/src/index';
import classNames from 'classnames';

export enum TreatmentCountFilter {
  OPPORTUNITIES = 'OPPORTUNITIES',
  UNSCHEDULED = 'UNSCHEDULED',
  SCHEDULED = 'SCHEDULED',
  COMPLETED = 'COMPLETED',
}

interface Props {
  count: number;
  disabled?: boolean;
  label: string;
  value: TreatmentCountFilter;
  hide?: boolean;
  isLoading?: boolean;
}

export const TreatmentCountItem = forwardRef<HTMLButtonElement, Props>(
  ({ count, disabled, label, value, hide = false, isLoading = false }, ref) => {
    const getBgColor = () => {
      switch (value) {
        case TreatmentCountFilter.OPPORTUNITIES:
          return `vai-bg-purple-700`;
        case TreatmentCountFilter.UNSCHEDULED:
          return `vai-bg-red-500`;
        case TreatmentCountFilter.SCHEDULED:
          return `vai-bg-slate-400`;
        case TreatmentCountFilter.COMPLETED:
          return `vai-bg-aqua-400`;
        default:
          return '';
      }
    };

    if (isLoading) {
      return <Skeleton className="vai-h-7 vai-w-full vai-rounded-md" />;
    }

    return (
      <ToggleGroupItem
        ref={ref}
        disabled={disabled}
        value={value}
        data-testid={`treatment-count-item-${value}`}
        className={classNames(
          'vai-bg-transparent vai-border-none vai-w-full vai-text-black vai-justify-start hover:vai-bg-slate-100 vai-text-base data-[state=on]:vai-bg-slate-200 vai-px-[6px] vai-py-1 vai-cursor-pointer vai-h-auto',
          {
            'disabled:!vai-opacity-100':
              disabled && value === TreatmentCountFilter.OPPORTUNITIES,
            'vai-invisible': hide, // Using `visibility: hidden` instead of `display: none` so the patient strip remains the same height
          },
        )}
      >
        <div
          className={classNames(
            'vai-flex vai-items-center vai-justify-center vai-w-5 vai-h-5 vai-text-white vai-rounded-[6px] vai-font-inter vai-text-[12px]',
            getBgColor(),
          )}
        >
          {count}
        </div>
        <span className="vai-text-sm vai-font-light vai-whitespace-nowrap">
          {label}
        </span>
      </ToggleGroupItem>
    );
  },
);
